import { EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { BehaviorSubject, Subject, takeUntil } from 'rxjs';
import { LgvClientService } from '../../core/core.module';
import { LgvModel } from '../../data-models/longevity.model';
import { ClientPickerModalComponent } from '../client-picker-modal/client-picker-modal.component';

@Component({
    selector: 'lus-client-picker',
    templateUrl: './client-picker.component.html',
    styleUrls: ['./client-picker.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ClientPickerComponent implements OnInit, OnDestroy {

    constructor(
        public MatDialog: MatDialog,
        public LgvClientSvc: LgvClientService) { }
    //@Input() ClientIDParam: string;

    @Input() ClientIDParam: string;
    @Output() ClientIDParamChange = new EventEmitter<string>();

    @Input() ClientSSParam: LgvModel.ClientSnapshot;


    @Output() OnSelectedClientDTO = new EventEmitter<LgvModel.ClientDTO>();
    //@Output() ClientSnapShot = new EventEmitter<LgvModel.ClientSnapshot>();
    //@Output() ClientSnapShotFailed = new EventEmitter<LgvModel.ClientSnapshot>();

    _ClientDTO: LgvModel.ClientDTO = null;
    ClientDTO$ = new BehaviorSubject(this._ClientDTO);
    onDestroy$ = new Subject();


    ngOnInit() {
    }

    ngOnDestroy() {
        this.onDestroy$.next(true);
        this.onDestroy$.complete();
    }

    OnOpenModal() {
        const dialogRef = this.MatDialog.open(ClientPickerModalComponent, {
            width: '450px',
            data: {}
        });

        dialogRef.afterClosed().pipe(takeUntil(this.onDestroy$)).subscribe(result => {
            console.log('Closing Dialog');
            if (result && result.action) {

                console.log(result);

                let clientDTO = result.clientDTO as LgvModel.ClientDTO;
                this.ClientDTO$.next(clientDTO);
                this.OnClientIDParamChange(clientDTO.id);
                this.OnSelectedClientDTO.emit(clientDTO);

                //    if (this.FetchSnapshot) {
                //        console.log('Fetching SS:');

                //        this.LgvClientSvc.FetchSnapshot(clientDTO.id)
                //            .subscribe(ss => {
                //                console.log('Have SS result:');
                //                console.log(ss);
                //                if (ss) {
                //                    this.ClientSnapShot.emit(ss);
                //                }
                //                else {
                //                    this.ClientSnapShotFailed.emit();
                //                }
                //            },
                //                err => {
                //                    console.log('Unable to load Snapshot for client');
                //                    this.ClientSnapShotFailed.emit();
                //                }
                //            );

                //    }
            }


        });
    }

    OnClientIDParamChange(clientID: string) {
        console.log(`OnClientIDParamChange => ${[clientID]}`);

        if (this.ClientIDParam !== clientID) {
            this.ClientIDParam = clientID;
            this.ClientIDParamChange.emit(clientID);
        }

    }
}
